const MobileHeightSetter = (top, step) => {
  const topEle = document.getElementById(top);
  const mobileBtn = document.getElementById('mobile-buttons');
  if (!topEle || !mobileBtn) return;
  const mobileHeight =
    mobileBtn.getBoundingClientRect().top - topEle.getBoundingClientRect().top;
  document.getElementById(top).style.height = `${
    step === 0 ? mobileHeight - 100 : mobileHeight
  }px`;
};

export default MobileHeightSetter;
